import { render } from "./ActivityContent.vue?vue&type=template&id=f6f39174"
import script from "./ActivityContent.vue?vue&type=script&lang=js"
export * from "./ActivityContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__